import {ApiClient} from '@hconnect/apiclient'

import {MaterialDemandByDay} from '../types'

export const MaterialDemandQueryKey = 'materialDemand'

export interface MaterialDemandQueryParams {
  fromDate: string
  toDate: string
}

/**
 * Query options for fetching material demand data
 */
export const materialDemandQueryOptions = (
  plantCode: string,
  params: MaterialDemandQueryParams
) => ({
  queryKey: [MaterialDemandQueryKey, plantCode, params] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const path = `/plants/${plantCode}/material-demand/daily`
    const response = await ApiClient.axiosInstance.get<MaterialDemandByDay>(path, {
      params: {from: params.fromDate, to: params.toDate},
      signal
    })
    return response.data
  }
})
